// extracted by mini-css-extract-plugin
module.exports = {"container":"EditExternalAccess_container__1aVwT","switch":"EditExternalAccess_switch__2JSxq"};